import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpCommonService } from "../../shared/services/http-common.service";
import { HttpClient } from "@angular/common/http";
import { IAgentResource, ICountry, AgentRequestForMaterial } from "../models/applicant.model";

@Injectable({ providedIn: "root" })
export class ApplicationHttpService<T> {
  private httpCommonService: HttpCommonService<T>;

  constructor(httpClient: HttpClient) {
    this.httpCommonService = new HttpCommonService<T>(httpClient);
  }

  public getRequest(request: string, objectName: any = null): Observable<T> {
    return this.httpCommonService.getHttpData(
      request,
      objectName
    ) as Observable<T>;
  }

  public postRequest(request: string, parameters: any): Observable<T> {
    return this.httpCommonService.post(request, parameters) as Observable<T>;
  }
}

//*** HttpServiceAgentResource ***

@Injectable({ providedIn: "root" })
export class HttpServiceAgentResource {
  protected httpCommonServiceAgentResource: HttpCommonService<IAgentResource[]>;

  constructor(private httpClient: HttpClient) {
    this.httpCommonServiceAgentResource = new HttpCommonService<
      IAgentResource[]
    >(httpClient);
  }

  public getAgentResourceRequest(
    request: string,
    objectName: any = null
  ): Observable<IAgentResource[]> {
    return this.httpCommonServiceAgentResource.getHttpData(
      request,
      objectName
    ) as Observable<IAgentResource[]>;
  }

  public refreshAgentResourceRequest(): Observable<IAgentResource[]> {
    return this.httpCommonServiceAgentResource.refresh() as Observable<
      IAgentResource[]
    >;
  }

  public postAgentResourceRequest(
    request: string,
    parameters: any
  ): Observable<IAgentResource[]> {
    return this.httpCommonServiceAgentResource.post(
      request,
      parameters
    ) as Observable<IAgentResource[]>;
  }

  downloadFile(request: string, fileName: string): any {
    return this.httpCommonServiceAgentResource.getFile(
      request + "/" + fileName,
      null
    );
  }

  checkIfFileExists(request: string, fileName: string): any {
    return this.httpCommonServiceAgentResource.get(
      request + "/" + fileName,
      null
    );
  }
}

//*** HttpServiceAgentResource ***

@Injectable({ providedIn: "root" })
export class HttpServiceAgentRequestForMaterial {
  protected httpCommonServiceAgentRequestForMaterial: HttpCommonService<
    AgentRequestForMaterial[]
  >;

  constructor(private httpClient: HttpClient) {
    this.httpCommonServiceAgentRequestForMaterial = new HttpCommonService<
      AgentRequestForMaterial[]
    >(httpClient);
  }

  public getAgentRequestForMaterialRequest(
    request: string,
    objectName: any = null
  ): Observable<AgentRequestForMaterial[]> {
    return this.httpCommonServiceAgentRequestForMaterial.getHttpData(
      request,
      objectName
    ) as Observable<AgentRequestForMaterial[]>;
  }

  public refreshAgentRequestForMaterialRequest(): Observable<
    AgentRequestForMaterial[]
  > {
    return this.httpCommonServiceAgentRequestForMaterial.refresh() as Observable<
      AgentRequestForMaterial[]
    >;
  }

  public postAgentRequestForMaterialRequest(
    request: string,
    parameters: any
  ): Observable<AgentRequestForMaterial[]> {
    return this.httpCommonServiceAgentRequestForMaterial.post(
      request,
      parameters
    ) as Observable<AgentRequestForMaterial[]>;
  }
}

/*** HttpServiceCountriesAndProvinces ***/

@Injectable({ providedIn: "root" })
export class HttpServiceCountriesAndProvinces {
  private httpCommonServiceCountriesAndProvinces: HttpCommonService<ICountry[]>;

  constructor(private httpClient: HttpClient) {
    this.httpCommonServiceCountriesAndProvinces = new HttpCommonService<
      ICountry[]
    >(httpClient);
  }

  public getCountriesAndProvincesRequest(
    request: string,
    objectName: any = null
  ): Observable<ICountry[]> {
    return this.httpCommonServiceCountriesAndProvinces.getHttpData(
      request,
      objectName
    ) as Observable<ICountry[]>;
  }

  public refreshCountriesAndProvincesRequest(): Observable<ICountry[]> {
    return this.httpCommonServiceCountriesAndProvinces.refresh() as Observable<
      ICountry[]
    >;
  }
}
